import { render, staticRenderFns } from "./PromoBillings.vue?vue&type=template&id=1275342d"
import script from "./PromoBillings.vue?vue&type=script&lang=js"
export * from "./PromoBillings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports